import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";
import { Identifiable, UnavailabilityReason } from "@planzone/dto";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  unavailabilityReasons: Identifiable<UnavailabilityReason>[];
  retrieveUnavailabilityReasons(
    request: Boundaries["retrieveUnavailabilityReasons"]["request"],
  ): void;
}

function useRetrieveUnavailabilityReasons(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveUnavailabilityReasonsRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveUnavailabilityReasonsRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveUnavailabilityReasonsRequestFailure,
    ),
    unavailabilityReasons: useSelector(selector.getUnavailabilityReasons),
    retrieveUnavailabilityReasons: core.retrieveUnavailabilityReasons,
  };
}

export { useRetrieveUnavailabilityReasons };
